import {
	HIDE_MESSAGE,
	INIT_URL,
	ON_HIDE_LOADER,
	ON_SHOW_LOADER,
	SHOW_MESSAGE,
	SIGNIN_USER_SUCCESS,
	SIGNOUT_USER_SUCCESS,
	AUTH_CHECK_START,
	AUTH_CHECK_COMPLETE,
} from "constants/ActionTypes";

const INIT_STATE = {
	loader: false,
	alertMessage: "",
	showMessage: false,
	initURL: "",
	authUser: null,
	permissions: null,
	authLoading: true,
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case SIGNIN_USER_SUCCESS: {
			return {
				...state,
				loader: false,
				authUser: action.payload,
				authLoading: false,
			};
		}
		case INIT_URL: {
			return {
				...state,
				initURL: action.payload,
			};
		}
		case SIGNOUT_USER_SUCCESS: {
			return {
				...state,
				authUser: null,
				initURL: "/app/dashboard",
				loader: false,
				permissions: null,
				authLoading: false,
			};
		}

		case AUTH_CHECK_START: {
			return { ...state, authLoading: true };
		}

		case AUTH_CHECK_COMPLETE: {
			return { ...state, authLoading: false };
		}

		case SHOW_MESSAGE: {
			return {
				...state,
				alertMessage: action.payload,
				showMessage: true,
				loader: false,
			};
		}
		case HIDE_MESSAGE: {
			return {
				...state,
				alertMessage: "",
				showMessage: false,
				loader: false,
			};
		}
		case ON_SHOW_LOADER: {
			return {
				...state,
				loader: true,
			};
		}
		case ON_HIDE_LOADER: {
			return {
				...state,
				loader: false,
			};
		}
		default:
			return state;
	}
};
